import { createApp } from "vue";
import SpnCompatibilitySummary from "./components/SpnCompatibilitySummary.vue";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-spn-compatibility-summary]";

export function initSpnCompatibilitySummaryApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(SpnCompatibilitySummary, {
      apiUrl: payload.apiUrl || "",
      initialSummary: payload.initialSummary || {},
      sheetId: Number.parseInt(String(payload.sheetId || "0"), 10) || 0,
      spnId: Number.parseInt(String(payload.spnId || "0"), 10) || 0,
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
